import { withRouter, useHistory, useLocation} from "react-router-dom";
import React, { useCallback, useEffect, useState, useRef, useLayoutEffect } from "react";
import {agmsClientRequestGet,agmsClientRequestPost} from "../../../apis/request";
import secureLocalStorage from "react-secure-storage";
import CircularProgress from '@mui/material/CircularProgress';
import { Modal } from "bootstrap";
import { useTranslation } from "react-i18next";

const OAuthLoginHandler = (props) => {
    const history = useHistory();
    const { t:translate, i18n } = useTranslation();
    const [email,setEmail] = useState('');
    const [forceToken, setForceToken] = useState(null);  
    ///////////////////////////
    const forceModalRef = useRef(null);
    const forceModalInstanceRef = useRef(null);

    
    useEffect(() => {
        if (!forceModalRef.current) return;

        // Bootstrap Modal 인스턴스 생성 (1회)
        forceModalInstanceRef.current =
            forceModalInstanceRef.current || new Modal(forceModalRef.current, {
            backdrop: "static", // 바깥 클릭시 닫히게 하려면 true
            keyboard: true,     // ESC로 닫기
            focus: true,
            });

        return () => {
            // 언마운트 시 정리
            forceModalInstanceRef.current?.dispose?.();
            forceModalInstanceRef.current = null;
        };
    }, []);

    const openForceModal = (e) => {
        // e.preventDefault();
        forceModalInstanceRef.current?.show();
    };

    const closeForceModal = () => {
    forceModalInstanceRef.current?.hide();
    };

    const onConfirmForceLogin = async (e) => {
        try{
            let code = new URL(window.location.href).searchParams.get("code");
            
            let result = await callOAuthApiForce(secureLocalStorage.getItem('oauthType'), code);

            // 강제 로그인 실패 등으로 result 없으면 중단(undefined.user_id 크래시 방지, 모달이 처리)
            if (!result) return;

            secureLocalStorage.setItem('userId', result.user_id);
        
            if(result.is_sign_up){
                //데이터를 저장.
                secureLocalStorage.setItem('oauthData', result);

                //회원가입 창으로 가야한다.
                history.push('/login', result);
            }
            else{
                //메인화면으로 가야한다.
                secureLocalStorage.setItem('accesstoken', result.access_token);
                secureLocalStorage.setItem('refreshtoken', result.refresh_token);
                secureLocalStorage.setItem("authUser", result.user_id);
                secureLocalStorage.setItem("email", result.email);
                secureLocalStorage.setItem("role", result.role);
                secureLocalStorage.setItem("oauthType", result.OAuth_type);
                secureLocalStorage.setItem("oauthData", null);
                history.push((Number(result.role) === 1001 || Number(result.role) === 1002) ? '/admin/users' : '/patient/list');
            }

        }
        catch(e){
            console.error('에러 발생:', e);
        }
        forceModalInstanceRef.current?.hide();
    };
    ///////////////////////////

    useEffect( async() => {
        try{
            let code = new URL(window.location.href).searchParams.get("code");
            
            let result = await callOAuthApi(secureLocalStorage.getItem('oauthType'), code);

            // 409(강제로그인)면 callOAuthApi가 모달만 띄우고 undefined 반환 → 여기서 중단. 이후는 모달 확인이 처리.
            if (!result) return;

            secureLocalStorage.setItem('userId', result.user_id);
        
            if(result.is_sign_up){
                //데이터를 저장.
                secureLocalStorage.setItem('oauthData', result);

                //회원가입 창으로 가야한다.
                history.push('/login', result);
            }
            else{
                //메인화면으로 가야한다.
                
                secureLocalStorage.setItem('accesstoken', result.access_token);
                secureLocalStorage.setItem('refreshtoken', result.refresh_token);
                secureLocalStorage.setItem("authUser", result.user_id);
                secureLocalStorage.setItem("email", result.email);
                secureLocalStorage.setItem("role", result.role);
                secureLocalStorage.setItem("oauthType", result.OAuth_type);
                secureLocalStorage.setItem("oauthData", null);
                history.push((Number(result.role) === 1001 || Number(result.role) === 1002) ? '/admin/users' : '/patient/list');
            }

        }
        catch(e){
            console.error('에러 발생:', e);
        }
    },[]);

    const callOAuthApi = async (type, code) =>{

        let result;

        if(type === 1801){ // 구글 코드 : 1801
            try{
                let body = {
                    auth_code: code,
                    login_type: 1801,
                    device_type_num: 1104,
                    is_forced: false
                };
                result = await agmsClientRequestPost(`/api/oauth/google`, body);
                secureLocalStorage.setItem('pre_signup_token', result.pre_signup_token);
            }
            catch(error){
                // 카카오와 동일: 409면 force 토큰 저장 후 강제로그인 팝업
                if (error.response?.status === 416) { alert(translate('try_find_password')); }
                else if (error.response?.status === 415) { alert(translate('already_registered_email')); }
                else if (error.response?.status === 412) { alert(translate('email_verification_expired')); }
                else if (error.response?.status === 409) { setEmail(error.response?.data.email); setForceToken(error.response?.data.force_login_token); openForceModal(); }
                else if (error.response?.status === 410) { if(error.response.data.result_code === 1004){ alert(translate('password_reset_expired')); } return; }
                else if (error.response?.status === 401) { if(error.response.data.result_code === 1002){ alert(translate('login_not_possible')); } else if(error.response.data.result_code === 1003){ alert(translate('password_mismatch_exceeded')); } }
                else { alert(translate('unable_to_login')); }
            }
        }
        else if(type === 1802){ //카카오 코드 : 1802

            try{
                let body = {
                    auth_code: code,
                    login_type: 1802,
                    device_type_num: 1104,
                    is_forced:false
                };

                result = await agmsClientRequestPost(`/api/oauth/kakao`, body);
                //메인화면으로 가야한다.
                secureLocalStorage.setItem('pre_signup_token', result.pre_signup_token);

                // secureLocalStorage.setItem('accesstoken', result.access_token);
                // secureLocalStorage.setItem('refreshtoken', result.refresh_token);
                // secureLocalStorage.setItem("authUser", result.user_id);
                // secureLocalStorage.setItem("email", result.email);
                // secureLocalStorage.setItem("role", result.role);
                // secureLocalStorage.setItem("oauthType", result.OAuth_type);
                // secureLocalStorage.setItem("oauthData", null);
                // history.push('/patient/list');

            }
            catch(error){
                if (error.response?.status === 416) {
                    alert(translate('try_find_password'));
                } 
                else if (error.response?.status === 415) {
                    alert(translate('already_registered_email'));
                }
                else if (error.response?.status === 412) {
                    alert(translate('email_verification_expired'));
                } 
                else if(error.response?.status === 409) {
                    setEmail(error.response?.data.email);
                    setForceToken(error.response?.data.force_login_token);
                    openForceModal();
                }
                else if(error.response?.status === 410){
                    if(error.response.data.result_code === 1004){
                    alert(translate('password_reset_expired'));
                    }
                    
                    return;
                }
                // else if (error.response?.status === 410) {
                //   alert("회원 인증 기간이 만료되었습니다.\n계정 메일로 보낸 재 인증 링크를 클릭하여 기간 연장 후 사용해 주세요.");
                // } 
                else if (error.response?.status === 401) {
                    if(error.response.data.result_code === 1002){
                    alert(translate('login_not_possible'));
                    }else if(error.response.data.result_code === 1003){
                    alert(translate('password_mismatch_exceeded'));
                    }
                    
                } else {
                    alert(translate('unable_to_login'));
                }
            }
            
        }

        return result;
    };

    const callOAuthApiForce = async (type, code) =>{

        let result;

        if(type === 1801){ // 구글 코드 : 1801
            let body = {
                auth_code: forceToken,
                login_type: 1801,
                device_type_num: 1104,
                is_forced: true
            };
            result = await agmsClientRequestPost(`/api/oauth/google`, body);
        }
        else if(type === 1802){ //카카오 코드 : 1802

            try{
                let body = {
                    auth_code: forceToken,
                    login_type: 1802,
                    device_type_num:1104,
                    is_forced:true
                };


                result = await agmsClientRequestPost(`/api/oauth/kakao`, body);
                //메인화면으로 가야한다.
                secureLocalStorage.setItem('accesstoken', result.access_token);
                secureLocalStorage.setItem('refreshtoken', result.refresh_token);
                secureLocalStorage.setItem("authUser", result.user_id);
                secureLocalStorage.setItem("email", result.email);
                secureLocalStorage.setItem("role", result.role);
                secureLocalStorage.setItem("oauthType", result.OAuth_type);
                secureLocalStorage.setItem("oauthData", null);
                history.push((Number(result.role) === 1001 || Number(result.role) === 1002) ? '/admin/users' : '/patient/list');

            }
            catch(error){
                if (error.response?.status === 416) {
                    alert(translate('try_find_password'));
                } 
                else if (error.response?.status === 415) {
                    alert(translate('already_registered_email'));
                }
                else if (error.response?.status === 412) {
                    alert(translate('email_verification_expired'));
                } 
                else if(error.response?.status === 409) {
                    openForceModal();
                }
                else if(error.response?.status === 410){
                    if(error.response.data.result_code === 1004){
                    alert(translate('password_reset_expired'));
                    }
                    
                    return;
                }
                // else if (error.response?.status === 410) {
                //   alert("회원 인증 기간이 만료되었습니다.\n계정 메일로 보낸 재 인증 링크를 클릭하여 기간 연장 후 사용해 주세요.");
                // } 
                else if (error.response?.status === 401) {
                    if(error.response.data.result_code === 1002){
                    alert(translate('login_not_possible'));
                    }else if(error.response.data.result_code === 1003){
                    alert(translate('password_mismatch_exceeded'));
                    }
                    
                } else {
                    alert(translate('unable_to_login'));
                }
            }
            
        }

       
        return result;
    };

    return (
        <div className="LoginHandeler" style={{
            width:'100vw',
            height:'80vh',
            display:'flex',
            justifyContent:'center',
            alignItems:'center'
        }}>
            <div className="notice" style={{
                display:'flex',
                flexDirection:'row',
                justifyContent:'center',
                alignItems:'center',
                border:'2px solid grey',
                borderRadius:'4px',
                paddingLeft:'50px',
                paddingTop:'50px',
                paddingBottom: '50px',
                paddingRight: '100px'
            }}> 
                <CircularProgress color="secondary" style={{
                    marginRight:'30px'
                }}/>
                <div style={{
                    display:'flex',
                    flexDirection:'column',
                    justifyContent:'center',
                    alignItems:'center'
                }}>
                    {/* <div style={{marginBottom:'20px'}}>로그인 중입니다.</div> */}
                    <div>잠시만 기다려주세요.</div>
                </div>
            </div>

            <div
                className="modal fade"
                tabIndex="-1"
                aria-hidden="true"
                ref={forceModalRef}
            >
                <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                    <h5 className="modal-title">강제 로그인</h5>
                    <button
                        type="button"
                        className="btn-close"
                        aria-label="Close"
                        onClick={closeForceModal}
                    />
                    </div>

                    <div className="modal-body">
                    이미 다른 기기에서 로그인된 세션이 있습니다.
                    <br />
                    기존 세션을 종료하고 강제 로그인 하시겠습니까?
                    </div>

                    <div className="modal-footer">
                    <button type="button" className="btn btn-outline-secondary" onClick={closeForceModal}>
                        취소
                    </button>
                    <button type="button" className="btn btn-danger" onClick={onConfirmForceLogin}>
                        강제 로그인 
                    </button>
                    </div>
                </div>
                </div>
            </div>
        </div>

        
    );
};
    
export default withRouter(OAuthLoginHandler);
